/*eslint-disable*/ export const messages = JSON.parse("{\"select.label.optional\":[\"(optional)\"]}");
//# sourceMappingURL=messages.mjs.map